import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../authentication';
import { environment } from '../../../environments/environment';
import { AppModuleRoutes } from '@app/app-routes';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        protected router: Router,
        protected authenticationService: AuthenticationService
    ) {}

    protected logStyle = 'color: #427f9c; background-color: #bfcf4f;';

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable((observer) => {

            const currentUser = this.authenticationService.currentUserValue;

            if (currentUser) {
                this.permissionsCheck(route, state)
                    .then((accessGranted: boolean) => {
                        if (!accessGranted && !environment.production && state && route && route.routeConfig) {
                            console.log(`%cAccess to url  '${state.url}' (route: ${route.routeConfig.path}) denied. Required permissions missing.`, this.logStyle);
                        }

                        observer.next(accessGranted);
                        observer.complete();
                });
            } else {
                this.notAuthenticatedAction()
                    .then(() => {
                        observer.next(false);
                        observer.complete();
                    });
            }

            return () => {};
        });
    }

    protected permissionsCheck(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return Promise.resolve(true);
    }

    protected notAuthenticatedAction(): Promise<boolean> {
        return this.router.navigateByUrl(AppModuleRoutes.AUTH);
    }

    protected unauthorisedAction(route?: ActivatedRouteSnapshot): Promise<boolean> {
        return this.router.navigateByUrl(AppModuleRoutes.DASHBOARD);
    }
}
